import React, { useState, useEffect, useRef, useMemo, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import ReactDatePicker, { registerLocale, setDefaultLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import { useBack } from "use-back";
import UserService from '../../Services/user.service';
import { deepOrange } from "@mui/material/colors";
import '../../pages/OtherDocuments/OtherDocument.css';
import '../../Components/AccountCardDashboard/FilterBar/FilterBar.css';
import backIcon from '../../assests/images/left-arrow.png';
import EnumsService from '../../Services/enums.service';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js'
import { ToastContainer, toast } from "react-toastify";
import DownloadIcon from '@mui/icons-material/Download';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import FilterListIcon from '@mui/icons-material/FilterList';
import DateRangeIcon from '@mui/icons-material/DateRange';
import { useSignalR } from '../../Contexts/signalR';
import { Dropdown } from 'primereact/dropdown';
import 'primereact/resources/themes/saga-blue/theme.css';  // Optional: PrimeReact theme
import 'primereact/resources/primereact.min.css';           // PrimeReact CSS
import 'primeicons/primeicons.css';
import SaveIcon from '@mui/icons-material/Save'; // Save icon
import ClearIcon from '@mui/icons-material/Clear';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AdvancedDropdown from '../../Components/AdvancedDropdown/AdvancedDropdown.js';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import MergeIcon from '@mui/icons-material/Merge';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import editIcon from '../../assests/images/Icons/editIcon.svg';
import PuffLoader from "react-spinners/PuffLoader";
import AssignmentService from '../../Services/assignment.service';
import ChatApiService from '../../Services/chat.service';
import Avatar from '@mui/material/Avatar';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // Import Quill's styling
import FileView from '../../Components/Assignments/SubComponents/FileView.js';
import AssignmentFilePreviewModal from '../../Components/Assignments/SubComponents/AssignmentFilePreviewModal.jsx';
import { PieChart } from '@mui/x-charts/PieChart';
import { LineChart } from '@mui/x-charts/LineChart';
import { BarChart } from '@mui/x-charts/BarChart';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { TablePagination } from '@mui/material';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext';
import AssignmentDialog from '../../Components/Assignments/SubComponents/AssignmentDialog.js';
import GenericTable from "../../Components/Assignments/SubComponents/AssignmentsTable.js";
import WorkPlanManager from "../../Components/Assignments/SubComponents/WorkPlanManager.js";
import AssignmentReportManager from "../../Components/Assignments/SubComponents/AssignmentReportManager.js";
import { Delta } from 'quill';
import './Assignments.css'
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';

// Function to calculate the first and last day of the current month



//table imports
import { Edit as EditIcon, Delete as DeleteIcon, Download as DownloadIconMui, Search as SearchIcon } from '@mui/icons-material';
import {
    Button, Dialog, DialogTitle, DialogContent, Box, DialogActions, Typography, TextField, Checkbox,
    InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, MenuItem,
    ToggleButton, ToggleButtonGroup, Switch, CircularProgress, IconButton, Tooltip, FormControlLabel, Divider,
    Grid, Chip
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { beautifyNumber } from '../../Utils/FormatNumber';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import styled from '@mui/system/styled';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import AutocompleteSelect from '../../Components/Widgets/AutocompleteSelect/AutocompleteSelect.jsx';
import Constants from '../../assests/Constants/constants';
import SubAccountantService from '../../Services/subAccountant.service';
import UserAvatar from '../../Components/Widgets/UserAvatar/UserAvatar.js';
import DOMPurify from 'dompurify';
import ClientService from '../../Services/client.service';
import { display } from '@mui/system';
import CustomMonthYearIndividualDatePicker from '../../Components/Widgets/CustomDates/CustomMonthYearIndividualDatePicker/CustomMonthYearIndividualDatePicker.js';
import CustomBreadcrumbs from '../../Components/CustomBreadcrumbs/CustomBreadcrumbs.jsx'

registerLocale('en-GB', {
    ...enGB,
    localize: {
        ...enGB.localize,
        month: n => n + 1, // Display months as numbers starting from 1
    },
    formatLong: {
        ...enGB.formatLong,
        date: () => 'MM/yyyy', // Date format when the picker is not showing
    },
});

setDefaultLocale('en-GB'); // Set the default locale to use it
const StyledDialogTitle = styled(DialogTitle)({
    fontSize: '1.8rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#304FFF',
});

const StyledDialogContent = styled(DialogContent)({
    textAlign: 'center',
    padding: '20px 30px',
});

const StyledDialogActions = styled(DialogActions)({
    justifyContent: 'center',
    paddingBottom: '20px',
});

const StyledButton = styled(Button)({
    margin: '0 8px',
    padding: '10px 20px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#fff',
    backgroundColor: '#E57C22',
    '&:hover': {
        backgroundColor: '#d9731a',
    },
});
const PaymentTypeOptions = [
    { name: "CreditCard", value: "0" },
    { name: "Check", value: "1" },
    { name: "BankTransfer", value: "2" },
    { name: "Cash", value: "3" }
];



const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    width: '100%',
    height: '10vh',
    '& .MuiAutocomplete-root': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center"
    },
    '& *': {
        boxSizing: 'border-box !important',
    },
    '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#BFC8FF',
        minHeight: '40px !important',
    },
    '& .MuiDataGrid-columnHeader': {
        backgroundColor: '#BFC8FF',
        padding: '4px 8px !important',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        color: '#304FFF',
        textAlign: 'center',
        fontFamily: 'Montserrat',
        fontSize: '12px',
        fontWeight: 600,
        lineHeight: '1.2',
    },
    '& .MuiDataGrid-cell': {
        borderTop: '1px solid rgba(191, 191, 193, 0.56)',
        backgroundColor: 'rgba(234, 237, 255, 0.32)',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        padding: '4px 8px !important',
        fontSize: '12px',
        lineHeight: '1.2',
    },
    '& .MuiDataGrid-row:hover': {
        backgroundColor: 'rgba(191, 200, 255, 0.3)',
    },
    '& .MuiDataGrid-cell:focus': {
        outline: 'none',
    },
    '& .MuiDataGrid-cell': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: "center"
    },
    '& .disableUser': {
        pointerEvents: 'none',
        opacity: 0.5,
    },
    // New styles for edit mode
    '& .MuiDataGrid-cell--editing': {
        paddingTop: '4px',
        paddingBottom: '4px',
        paddingLeft: '4px',
        paddingRight: '4px',
    },
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell': {
        borderRight: 'none',
    },
    '& .MuiDataGrid-row--editing .MuiDataGrid-cell:not(:last-child)': {
        borderRight: '4px solid transparent',
    },
    '& .MuiDataGrid-cell--editing': {
        padding: 0,
        backgroundColor: 'inherit',
    },
}));

const OptionButton = styled(Button)({
    margin: '10px 8px',
    padding: '12px 25px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#304FFF',
    backgroundColor: '#f5f5f5',
    border: '1px solid #E57C22',
    width: 'auto',  // Allows the button to shrink when there are many buttons
    maxWidth: '200px',  // Set a maximum width to ensure consistency
    flexGrow: 1,  // Allows buttons to fill available space equally
    '&:hover': {
        backgroundColor: '#E57C22',
        color: '#fff',
    },
});

const ActionButton = styled(Button)({
    backgroundColor: '#E57C22', // Consistent background with other elements
    borderRadius: 4, // Same border-radius as MUI TextField and Switch
    color: 'white',
    height: 40, // Same height as other input elements
    padding: '0 16px', // Consistent padding
    fontSize: '0.875rem', // Matching font size with TextField
    textTransform: 'none',
    boxSizing: 'border-box',
    '&:hover': {
        backgroundColor: '#d9731a', // Slightly darker on hover
    },
    '&:disabled': {
        backgroundColor: '#E0E0E0',
        color: '#BDBDBD',
    },
});



function Assignments() {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const direction = i18n.dir();
    const [documentTypeFetch, setDocumentTypeFetch] = useState('');
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const [client, setClient] = useState(null);
    const [type, setType] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [isClientDataFetched, setIsClientDataFetched] = useState(false);
    const [hasOpenedAssignmentModal, setHasOpenedAssignmentModal] = useState(false);

    const [sortConfig, setSortConfig] = useState({ key: 'cardId', direction: 'descending', type: 'number' });
    const [focused, setFocused] = useState(false);
    const customScrollbarRef = useRef();
    const tableContainerRef = useRef();
    const [calculatedWidth, setCalculatedWidth] = useState('70%');
    const [currentUserType, setCurrentUserType] = useState(0);
    const { goBack } = useContext(NavHistoryContext);

    const { setMenuProps } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    //account cards
    const emptyAssignment = {
        id: null,
        accountantId: user?.accountantId || "",
        caseId: null,
        reporterId: user?.subAccountantId || user?.accountantId || "",
        reporterType: currentUserType,
        assigneeId: "",
        assigneeType: null,
        summary: "",
        description: "",
        priority: 0,
        estimatedTime: 1, // Default estimated time in hours
        status: 0,
        createDate: new Date().toISOString(),
        dueDate: new Date().toISOString(),
        isPrivate: false,
        attachedDocuments: [],
        comments: [],
    };

    const fileInputRef1 = useRef(null); // Reference to the first hidden file input



    // const handleFileChange = (event, uploadFunction) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         uploadFunction(file); // Call the passed upload function with the selected file
    //     }
    // };

    // const handleFileButtonClick = (fileInputRef, uploadFunction) => {
    //     // Reset the file input value
    //     fileInputRef.current.value = '';

    //     // Set up the onchange event handler
    //     fileInputRef.current.onchange = (event) => handleFileChange(event, uploadFunction);

    //     // Trigger the file input click
    //     fileInputRef.current.click();
    // };

    const handleFileChange = (event) => {
        const files = event.target.files;
        if (files?.length) {
            handleAddFilesToAssignment(Array.from(files));
        }
        event.target.value = '';
    };

    const handleUploadClick = () => {
        if (fileInputRefUpload.current?.open) {
            fileInputRefUpload.current.open();
        }
    };

    const [collectionPageData, setCollectionPageData] = useState({});
    // const [startDate, setStartDate] = useState(() => {
    //     const storedDateString = localStorage.getItem('_StartDate');
    //     return storedDateString ? new Date(storedDateString) : new Date();
    // });;

    const [assignmentsPage, setAssignmentsPage] = useState([]);
    const [subAccountants, setSubAccountants] = useState([]);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    const [selectedAssignment, setSelectedAssignment] = useState(null);

    const [filePreviewModalOpen, setFilePreviewModalOpen] = useState(false);
    const [previewFileInfo, setPreviewFileInfo] = useState({ url: '', fileName: '', mimeType: '' });

    const handleOpenModal = (url, fileName, mimeType) => {
        setPreviewFileInfo({ url: url || '', fileName: fileName || '', mimeType: mimeType || '' });
        setFilePreviewModalOpen(true);
    };

    const handleCloseFilePreviewModal = () => {
        setFilePreviewModalOpen(false);
        setPreviewFileInfo({ url: '', fileName: '', mimeType: '' });
    };

    const [newComment, setNewComment] = useState({
        content: '',
        attachedDocuments: [],
    });
    const [currentAssignment, setCurrentAssignment] = useState({});
    const [currentDescription, setCurrentDescription] = useState('');
    const [categoryToEditOrDelete, setCategoryToEditOrDelete] = useState(null);

    const isRichTextEmpty = (html) => {
        if (!html) return true;
        const text = String(html)
            .replace(/<[^>]*>/g, ' ')
            .replace(/&nbsp;/gi, ' ')
            .replace(/\s+/g, ' ')
            .trim();
        return text.length === 0;
    };

    const handleEditCategory = (category) => {
        setCategoryToEditOrDelete(category);

        setEditCategoryModalOpen(true);
    }

    const handleChangeNewCommentContent = (content) => {
        setNewComment((prev) => ({
            ...prev,
            content,
        }));
    };

    const handleChangeCurrentDescription = (description) => {
        setCurrentAssignment((prev) => ({
            ...prev,
            description,
        }));
    };


    useEffect(() => {
        const filteredAssignmentss = assignmentsPage.filter(
            (assignment) => assignment.status === 2
        );
    }, [subAccountants]);






    const [caseIdOptions, setCaseIdOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);


    const [subAccountantOptions, setSubAccountantOptions] = useState([]);

    const [useDateFilter, setUseDateFilter] = useState(false); // Toggle to enable/disable date filtering
    const [isRange, setIsRange] = useState(false); // Toggle single date or range
    const [startDate, setStartDate] = useState(() => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), 1); // First day of the current month
    });

    const [endDate, setEndDate] = useState(() => {
        const now = new Date();
        return new Date(now.getFullYear(), now.getMonth() + 1, 0); // Last day of the current month
    });

    const [sortDate, setSortDate] = useState(dayjs()); // Default for single date
    const [asccountant, setAccountant] = useState({});
    const todoTableRef = useRef(null);

    /** Bumps on each fetchEnums / standalone assignments fetch; stale async work ignores results (Strict Mode / overlapping calls). */
    const enumsLoadGenRef = useRef(0);
    /** Latest user/token/client for effects that must not depend on those in the dependency array (avoids duplicate initial load). */
    const userRef = useRef(null);
    const tokenRef = useRef('');
    const clientRef = useRef(null);
    /** Initial session load: ignore stale async when deps change or React Strict Mode re-runs the effect. */
    const userDataLoadIdRef = useRef(0);

    useEffect(() => {
        userRef.current = user;
        tokenRef.current = token;
        clientRef.current = client;
    }, [user, token, client]);

    const fetchEnums = async (user, token, client) => {
        if (!user?.accountantId) {
            setLoading(false);
            return;
        }

        const gen = ++enumsLoadGenRef.current;
        setLoading(true);

        try {

            await fetchAssignments(null, null, isRange, user.accountantId, token, client?.caseId, gen);
            if (gen !== enumsLoadGenRef.current) return;

            const result2 = await SubAccountantService.GetSubAccountantByAccountantId(token, user.accountantId);
            if (gen !== enumsLoadGenRef.current) return;
            const accountantResult = await SubAccountantService.GetAccountantById(token, user.accountantId);
            if (gen !== enumsLoadGenRef.current) return;

            const categoriesResponse = await AssignmentService.GetAllAssignmentCategories(user.accountantId, token);
            if (gen !== enumsLoadGenRef.current) return;
            const enhancedAccountantResult = {
                ...accountantResult,
                subAccountantId: accountantResult.accountantId, // Add subAccountantId as same as accountantId
            };
            if (gen !== enumsLoadGenRef.current) return;
            setAccountant(enhancedAccountantResult);

            const clientsData = await ClientService.GetMinimalClients(user.accountantId, token, 1, 1000, true);
            if (gen !== enumsLoadGenRef.current) return;

            //getting subaccountants
            if (result2) {

                const combinedSubAccountants = [enhancedAccountantResult, ...result2];
                setSubAccountants(combinedSubAccountants);
                const combinedOptions = combinedSubAccountants.map((acc) => ({
                    value: acc.subAccountantId,
                    label: acc.name,
                }));

                setSubAccountantOptions(combinedOptions);
            } else {
                toast.error(t('fetchSubAccountantsDataError'));
            }

            if (gen !== enumsLoadGenRef.current) return;

            if (clientsData) {
                const caseIdOptions = [
                    {
                        value: null,
                        // deductionsCase: null,
                        label: t('Office'),
                    },
                    ...clientsData.clients.map((client) => ({
                        value: client.caseId,
                        // deductionsCase: client.deductionsCase,
                        label: client.name,
                    })),
                ];
                setCaseIdOptions(caseIdOptions);
            } else {
                toast.error(t('fetchClientsDataError'));
            }

            if (gen !== enumsLoadGenRef.current) return;

            if (categoriesResponse.ok) {
                const categoriesData = await categoriesResponse.json();
                if (gen !== enumsLoadGenRef.current) return;

                // Add special "new category" item as the first item
                const mappedCategories = [
                    {
                        value: "NEW_CATEGORY",
                        label: t("AddNewCategory"), // e.g. "➕ Add New Category"
                    },
                    ...categoriesData.map((cat) => ({
                        value: cat.id,
                        label: cat.name,
                    })),
                ];

                setCategoryOptions(mappedCategories);

            } else {
                toast.error(t("FailedToRetrieveCategories"));
            }

            if (gen === enumsLoadGenRef.current) {
                setIsClientDataFetched(true);
                setLoading(false);
            }
        } catch (error) {

            toast.error(t('fetchEnumsError'), error);
            // Handle the error appropriately
            setIsClientDataFetched(false);
            if (gen === enumsLoadGenRef.current) {
                setLoading(false);
            }

        }

    };

    /**
     * @param linkedGen — when provided (from fetchEnums), only this generation may apply results; omit for standalone refresh.
     */
    const fetchAssignments = async (startDate = null, endDate = null, isRange, accountantId, token, caseId, linkedGen) => {
        const myGen = linkedGen != null ? linkedGen : ++enumsLoadGenRef.current;
        try {
            const response = await AssignmentService.GetAssignmentsByAccountantId(
                accountantId,
                token,
                startDate ? dayjs(startDate) : null,
                (isRange && endDate) ? dayjs(endDate) : null,
                caseId
            );

            if (myGen !== enumsLoadGenRef.current) return null;

            if (response.ok) {
                const result = await response.json();
                if (myGen !== enumsLoadGenRef.current) return null;
                setAssignmentsPage(result); // Return the result to handle it where needed
                setLoading(false);

            } else {
                toast.error(t('FailedToGetCollectionPage'));
                if (myGen === enumsLoadGenRef.current) {
                    setLoading(false);
                }
                return null;
            }
        } catch (error) {
            console.error("Error fetching assignments:", error);
            toast.error(t('ErrorFetchingAssignments'));
            if (myGen === enumsLoadGenRef.current) {
                setLoading(false);
            }
            return null;
        }
        return null;
    };




    const handleCloseDialog = () => {
        const hasDraftComment =
            !isRichTextEmpty(newComment?.content) ||
            (Array.isArray(newComment?.attachedDocuments) && newComment.attachedDocuments.length > 0);

        if (hasDraftComment) {
            const ok = window.confirm(
                t("UnsavedNoteWillBeLost") || "You have an unsaved note. Closing will discard it. Close anyway?"
            );
            if (!ok) return;
            setNewComment({ content: '', attachedDocuments: [] });
        }
        setDialogOpen(false);
        setHasOpenedAssignmentModal(false);
    };

    // Function to handle input changes for the assignment fields
    const handleAssignmentChange = (field, value) => {
        setCurrentAssignment((prev) => ({
            ...prev,
            [field]: value,
        }));
    };




    const handleAddComment = async (assignmentId) => {
        try {


            // Create a FormData object to send the data as multipart/form-data
            const formData = new FormData();
            formData.append('AccountantId', user.accountantId);
            formData.append('AssignmentId', assignmentId);
            formData.append('CommentorId', user.subAccountantId || user.accountantId);
            formData.append('CommentorName', user.name);
            formData.append('CommentorType', currentUserType);
            formData.append('Content', newComment.content);

            // Append each file in `newAttachedDocuments` to the formData
            if (newComment.attachedDocuments && newComment.attachedDocuments.length > 0) {
                newComment.attachedDocuments.forEach((file) => {
                    formData.append("NewAttachedDocuments", file, file.name); // Backend expects "NewAttachedDocuments"
                });
            }
            // Call the AddComment method with FormData
            const response = await AssignmentService.AddComment(formData, token);

            if (response.ok) {
                const createdComment = await response.json();
                setCurrentAssignment((prev) => ({
                    ...prev,
                    comments: [...prev.comments, createdComment],
                }));
                setNewComment({ content: '', attachedDocuments: [] }); // Reset newComment state
                toast.success(t("CommentAddedSuccessfully"));
                fetchAssignments(
                    useDateFilter ? startDate : null, 
                    useDateFilter ? endDate : null, 
                    isRange, 
                    user.accountantId, 
                    token, 
                    client?.caseId
                );

            } else {
                toast.error(t("FailedToAddComment"));
            }
        } catch (error) {
            console.error("Error adding comment:", error);
            toast.error(t("AnErrorOccurredWhileAddingComment"));
        }
    };


    // Function to save changes
    const handleSaveChanges = async () => {
        try {
            // API call to update the assignment
            const response = await AssignmentService.UpdateAssignment(currentAssignment, token);
            if (response.ok) {
                toast.success(t('AssignmentUpdatedSuccessfully'));
                // Refresh data after successful update
                await fetchEnums(user, token, client);
            } else {
                toast.error(t('FailedToUpdateAssignment'));
            }
        } catch (error) {
            console.error(error);
            toast.error(t('AnErrorOccurredWhileUpdating'));
        } finally {
            handleCloseDialog();
        }
    };

    const handleAddAssignment = () => {
        setCurrentAssignment(emptyAssignment); // Set the empty assignment
        setIsAddMode(true); // Set to Add Mode
        setIsEditMode(true); // Open the form for editing
        setDialogOpen(true); // Open the dialog
    };


    const [selectedCaseIds, setSelectedCaseIds] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);


    const setSingleCaseId = (caseId) => {
        setSelectedCaseIds([caseId]);
    };

    const handleSetSelectedCaseIds = (value) => {
        if (client) {
            setClient(null);
            fetchAssignments(
                useDateFilter ? startDate : null, 
                useDateFilter ? endDate : null, 
                isRange, 
                user.accountantId, 
                token, 
                null
            );
        }
        setSelectedCaseIds(value);
    };

    useEffect(() => {
        const loadId = ++userDataLoadIdRef.current;
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const currentUser = await UserService.getCurrentUser();
                if (loadId !== userDataLoadIdRef.current) return;

                const currentToken = await UserService.getCurrentToken();
                if (loadId !== userDataLoadIdRef.current) return;

                const currentUserType = await UserService.getCurrentUserType();
                if (loadId !== userDataLoadIdRef.current) return;

                if (currentUser && currentToken && currentUserType) {
                    setUser(currentUser);

                    setCurrentUserType(currentUserType);
                    setToken(currentToken);

                    // Get client data from location.state
                    if (location.state && location.state.type) {
                        setType(location.state.type)

                    }
                    if (location.state && location.state.client) {
                        setClient(location.state.client);
                        setSingleCaseId({ value: location.state.client.caseId, label: location.state.client.name });
                    }
                    if (loadId !== userDataLoadIdRef.current) return;

                    await fetchEnums(currentUser, currentToken, location.state?.client);
                }
                else {
                    if (loadId === userDataLoadIdRef.current) {
                        setLoading(false);
                        navigate("/login");
                    }
                }


            } catch (error) {
                if (loadId === userDataLoadIdRef.current) {
                    setLoading(false);
                }
            }
        };
        fetchUserData();
    }, [location.state.client]);

    const [cardIdOption, setCardIdOption] = useState(-1);



    const formatDate = dateString => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateWithHour = (dateString) => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        return `${day}-${month}-${year} ${hours}:${minutes}`;
    };




    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        setSortConfig({ key, direction, type });
    };

    // table functions
    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold'
    }


    useEffect(() => {
        // Calculate the width as 70% of the container width minus 20px
        const containerWidth = document.querySelector('.table-container').offsetWidth;
        const newWidth = (containerWidth * 0.7) - 20;
        setCalculatedWidth(newWidth + 'px');
    }, []);


    const { hasBack, handleBack } = useBack();

    const handleGoBack = () => {
        // handleBack();
        goBack()
    };





    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [deleteModalVisable, setDeleteModalVisable] = useState(null);


    const formatDate2 = (value) => {

        if (!value) {
            return "-"
        }
        return dayjs(value).format('MM/YYYY');
    };

    // Define columns for each DataGrid


    const [isConfirmModalVisable, setIsConfirmModalVisable] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [itemType, setItemType] = useState('');
    const [newItem, setNewItem] = useState({}); // State to hold new item data


    useEffect(() => {
        if (!startDate) return;
        const u = userRef.current;
        const tk = tokenRef.current;
        if (!tk || !u?.accountantId) return;
        fetchEnums(u, tk, clientRef.current);
    }, [startDate]);

    // Handle opening specific assignment modal when assignments are loaded
    useEffect(() => {
        if (location.state && location.state.openAssignmentId && assignmentsPage.length > 0 && !hasOpenedAssignmentModal) {
            const assignmentId = location.state.openAssignmentId;
            const assignment = assignmentsPage.find(a => a.id === assignmentId);
            if (assignment) {
                setCurrentAssignment(assignment);
                setDialogOpen(true);
                setIsEditMode(false);
                setIsAddMode(false);
                setHasOpenedAssignmentModal(true);
                
                // Clear the openAssignmentId from location state to prevent reopening
                const newState = { ...location.state };
                delete newState.openAssignmentId;
                navigate(location.pathname, { state: newState, replace: true });
            }
        }
    }, [assignmentsPage, location.state, navigate, hasOpenedAssignmentModal]);



    const getSubAccountantName = (subAccountantId) => {
        const subAccountant = subAccountants.find(sa => sa.subAccountantId === subAccountantId);
        return subAccountant ? subAccountant.name : t("NoAssignee");
    };

    const getClientName = (caseId) => {



        const clients = caseIdOptions.find(c => c.value === caseId);
        return clients ? clients.label : '-';
    };

    const [clickedTable, setClickedTable] = useState('');

    const columns = [
        {
            label: t("Assignments"),
            field: "summary",
            render: (row) => {
                const priorityEmoji = Constants.PriorityEmojis[
                    Object.keys(Constants.PriorityEnum).find(
                        (key) => Constants.PriorityEnum[key] === row.priority
                    )
                ];
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                        {row.isPrivate && (
                            <Tooltip title={t("PrivateAssignmentTooltip")}>
                                <Chip
                                    size="small"
                                    icon={<LockOutlinedIcon sx={{ fontSize: '14px !important' }} />}
                                    label={t("PrivateAssignment")}
                                    sx={{ height: 22, fontSize: 11, bgcolor: '#ECEFF1', color: '#546E7A' }}
                                />
                            </Tooltip>
                        )}
                        <span>{priorityEmoji} {row.summary}</span>
                    </Box>
                );
            },
        },
        {
            label: t("DueDate"),
            field: "dueDate",
            render: (row) => formatDate(row.dueDate),
        },
        {
            label: t("Assignee"),
            field: "assigneeId",
            render: (row) => {
                const assigneeName = getSubAccountantName(row.assigneeId); // Fetch the name
                return <UserAvatar size={18} name={assigneeName} />;
            },
        },
        {
            label: t("Client Name"),
            field: "caseId",
            render: (row) => {
                const clientName = getClientName(row.caseId); // Fetch the name
                return clientName && clientName !== '-'
                    ? <UserAvatar size={18} name={clientName} />
                    : '-';
            },
        },
        {
            label: t("Category"),
            field: "category",
            render: (row) => {
                const matchedCategory = categoryOptions.find(option => option.value === row.category);
                return matchedCategory ? matchedCategory.label : "-"; // Fallback to "-" if no match is found
            }
        },
        {
            label: t("Est. Time (d)"),
            field: "estimatedTime",
            render: (row) => {
                const hours = row.estimatedTime || 1;
                const days = (hours / 8).toFixed(1);
                return days;
            },
        },
        ...(clickedTable
            ? [
                {
                    label: t("CreateDate"),
                    field: "createDate",
                    render: (row) => formatDate(row.createDate),
                },
                {
                    label: t("Description"),
                    field: "description",
                    render: (row) => (
                        <div
                            dangerouslySetInnerHTML={{ __html: row.description }}
                        />
                    ),
                },

            ]
            : []),
    ];

    const getConfirmMessage = () => {
        const actionType = 'assignment';

        switch (actionType) {
            case 'assignment':
                return t('AreYouSureDeleteAssignment');
            default:
                return t('confirmDeleteMessage');

        }
    };


    const getTitleMessage = () => {
        const actionType = 'assignment';
        switch (actionType) {

            case 'assignment':
                return t('ConfirmDeleteAssignments');

            default:
                return t('confirmDeleteTitle');
        }
    };

    const columnsDoneTable = [
        {
            label: t("Assignments"),
            field: "summary",
            render: (row) => {
                const priorityEmoji = Constants.PriorityEmojis[
                    Object.keys(Constants.PriorityEnum).find(
                        (key) => Constants.PriorityEnum[key] === row.priority
                    )
                ];
                return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap' }}>
                        {row.isPrivate && (
                            <Tooltip title={t("PrivateAssignmentTooltip")}>
                                <Chip
                                    size="small"
                                    icon={<LockOutlinedIcon sx={{ fontSize: '14px !important' }} />}
                                    label={t("PrivateAssignment")}
                                    sx={{ height: 22, fontSize: 11, bgcolor: '#ECEFF1', color: '#546E7A' }}
                                />
                            </Tooltip>
                        )}
                        <span>{priorityEmoji} {row.summary}</span>
                    </Box>
                );
            },
        },
        { label: t("DueDate"), field: "dueDate", render: (row) => formatDate(row.dueDate) },
        {
            label: t("Assignee"),
            field: "assigneeId",
            render: (row) => {
                const assigneeName = getSubAccountantName(row.assigneeId); // Fetch the name

                return (
                    <UserAvatar size={18} name={assigneeName} />
                );
            },
        },
        {
            label: t("Client Name"),
            field: "caseId",
            render: (row) => {
                const clientName = getClientName(row.caseId); // Fetch the name

                return clientName && clientName !== '-'
                    ? <UserAvatar size={18} name={clientName} />
                    : '-';
            },
        },
        {
            label: t("DoneDate"),
            field: "finishDate",
            render: (row) => row.finishDate ? formatDate(row.finishDate) : "-"
        },
        {
            label: t("Category"),
            field: "category",
            render: (row) => {
                const matchedCategory = categoryOptions.find(option => option.value === row.category);
                return matchedCategory ? matchedCategory.label : "-"; // Fallback to "-" if no match is found
            }
        },
        {
            label: t("Est. Time (d)"),
            field: "estimatedTime",
            render: (row) => {
                const hours = row.estimatedTime || 1;
                const days = (hours / 8).toFixed(1);
                return days;
            },
        },
        ...(clickedTable
            ? [
                {
                    label: t("CreateDate"),
                    field: "createDate",
                    render: (row) => formatDate(row.createDate),
                },
                {
                    label: t("Description"),
                    field: "description",
                    render: (row) => (
                        <div
                            dangerouslySetInnerHTML={{ __html: row.description }}
                        />
                    ),
                },
            ]
            : []),

    ];

    const handleUpdateAssignmentStatus = async (assignmentId, newStatus) => {
        setLoading(true);
        try {
            const response = await AssignmentService.UpdateAssignmentStatus(user.accountantId, assignmentId, newStatus, token);
            if (response.ok) {
                let finishDate = null;
                try {
                    const finishDateRaw = await response.text();
                    finishDate = finishDateRaw.replace(/^"|"$/g, '') || null; // Remove leading and trailing quotes


                } catch (error) {
                    toast.error("Response is not valid JSON");
                }


                if (finishDate !== null) {

                    setAssignmentsPage((prevAssignments) =>
                        prevAssignments.map((assignment) => {
                            if (assignment.id === assignmentId) {
                                return {
                                    ...assignment,
                                    status: newStatus,
                                    finishDate: finishDate, // Add the new finishDate
                                };
                            }
                            return assignment;
                        })
                    );
                }
            } else {
                toast.error(t("ErrorUpdatingStatus"));
            }
        } catch (error) {
            toast.error(t("FailedToUpdateStatus"));
        } finally {
            setLoading(false);
        }
    };

    const handleStatusChange = (assignmentId, newStatus) => {
        setAssignmentsPage((prevAssignments) =>
            prevAssignments.map((assignment) =>
                assignment.id === assignmentId
                    ? { ...assignment, status: newStatus }
                    : assignment
            )
        );

        handleUpdateAssignmentStatus(assignmentId, newStatus);
    };

    const [todoScrollPos, setTodoScrollPos] = useState(0);
    const tableRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);

    const handleChangeClickedTable = (whatTable) => {
        if (clickedTable === whatTable) {
            setClickedTable('')
        } else {
            setClickedTable(whatTable)
        }
    }






    const [isEditMode, setIsEditMode] = useState(false); // Track edit mode
    const [isAddMode, setIsAddMode] = useState(false);

    const handleEditAssignment = () => {
        setIsEditMode(true); // Enable edit mode
    };


    const handleOpenEditDialog = (assignment) => {
        setCurrentAssignment(assignment);
        setDialogOpen(true);
        setIsEditMode(false);
        setIsAddMode(false);
    };

    const handleDeleteClick = async () => {
        try {
            const response = await AssignmentService.DeleteAssignment(currentAssignment.id, user.accountantId, token);
            if (response.ok) {
                toast.success(t("AssignmentDeletedSuccessfully"));
                setAssignmentsPage((prevAssignments) =>
                    prevAssignments.filter((assignment) => assignment.id !== currentAssignment.id)
                );
                setDialogOpen(false);
                setIsConfirmModalVisable(false);
            } else {
                const errorMessage = await response.text();
                toast.error("FailedToDeleteAssignment");
            }
        } catch (error) {
            toast.error(t("FailedToDeleteAssignment"));
        }
    };

    const validateFieldsBeforeSave = (user, currentAssignment, t) => {
        const missingFields = [];


        if (!currentAssignment?.summary) {
            missingFields.push(t('SummaryMissing')); // Translation for missing Summary
        }
        // if (!currentAssignment?.description) {
        //     missingFields.push(t('DescriptionMissing')); // Translation for missing Description
        // }
        if (currentAssignment?.priority === null || currentAssignment?.priority === undefined) {
            missingFields.push(t('PriorityMissing')); // Translation for missing Priority
        }


        if (missingFields.length > 0) {
            // Show a toast for each missing field
            missingFields.forEach(field => {
                toast.info(field);
            });
            return false; // Validation failed
        }

        return true; // Validation passed
    };



    // Sends a chat message to the assignee letting them know a new
    // assignment was assigned to them and asking them to handle it.
    const notifyAssigneeViaChat = async (assignment) => {
        try {
            const assigneeId = assignment?.assigneeId;
            if (!assigneeId) return;

            // The assignee is either the main accountant or a sub-accountant.
            const receiverType =
                assigneeId === user.accountantId
                    ? Constants.UserTypeInt.Accountant
                    : Constants.UserTypeInt.SubAccountant;

            const senderId = user.subAccountantId || user.accountantId;
            const senderType = currentUserType
                ? String(currentUserType)
                : (user.subAccountantId
                    ? Constants.UserType.SubAccountant
                    : Constants.UserType.Accountant);

            // Build a detailed message with the key assignment fields.
            const lines = [t("NewAssignmentAssignedChatMessage")];

            if (assignment?.summary) {
                lines.push(`📋 ${t("AssignmentTitle")}: ${assignment.summary}`);
            }

            const clientName = caseIdOptions?.find((c) => c.value === assignment?.caseId)?.label;
            if (clientName) {
                lines.push(`👤 ${t("Client Name")}: ${clientName}`);
            }

            const priorityKey = Object.keys(Constants.PriorityEnum).find(
                (k) => Constants.PriorityEnum[k] === assignment?.priority
            );
            if (priorityKey) {
                lines.push(`⚡ ${t("Priority")}: ${t(priorityKey)}`);
            }

            if (assignment?.dueDate) {
                const due = new Date(assignment.dueDate);
                if (!isNaN(due.getTime())) {
                    lines.push(`📅 ${t("DueDate")}: ${due.toLocaleDateString("en-GB")}`);
                }
            }

            const estimated = assignment?.estimatedTime || 0;
            if (estimated > 0) {
                const days = Math.floor(estimated / 8);
                const hours = estimated % 8;
                const parts = [];
                if (days > 0) parts.push(`${days} ${t("Days")}`);
                if (hours > 0) parts.push(`${hours} ${t("Hours")}`);
                if (parts.length) {
                    lines.push(`⏱️ ${t("EstimatedTime")}: ${parts.join(", ")}`);
                }
            }

            if (assignment?.description) {
                const plainDescription = assignment.description
                    .replace(/<[^>]+>/g, " ")
                    .replace(/\s+/g, " ")
                    .trim();
                if (plainDescription) {
                    lines.push(`📝 ${t("Description")}: ${plainDescription}`);
                }
            }

            const content = lines.join("\n");

            const formData = new FormData();
            formData.append("SenderId", senderId);
            formData.append("SenderName", user.name || "");
            formData.append("SenderType", senderType);
            formData.append("ReceiverId", assigneeId);
            formData.append("ReceiverType", String(receiverType));
            formData.append("MessageType", "0");
            formData.append("MessageContent", content);

            await ChatApiService.sendMessage(formData);
        } catch (error) {
            console.error("Error notifying assignee via chat:", error);
        }
    };

    const handleSaveAssignment = async () => {
        if (!validateFieldsBeforeSave(user, currentAssignment, t)) {
            return
        }
        setLoading(true);
        try {
            const formData = new FormData();

            formData.append('AccountantId', user.accountantId);
            formData.append('ReporterId', user.subAccountantId || user.accountantId);
            formData.append('ReporterType', currentUserType);
            formData.append('AssigneeId', currentAssignment.assigneeId || "");
            // Never send the literal string "null" for nullable enums — omit or use a real value.
            const assigneeTypeValue = (() => {
                const raw = currentAssignment.assigneeType;
                if (raw !== null && raw !== undefined && raw !== '' && String(raw) !== 'null') {
                    return String(raw);
                }
                if (!currentAssignment.assigneeId) return null;
                // Main office accountant is often in the assignee list with accountantId as subAccountantId
                return currentAssignment.assigneeId === user.accountantId
                    ? String(Constants.UserTypeInt.Accountant)
                    : String(Constants.UserTypeInt.SubAccountant);
            })();
            if (assigneeTypeValue != null) {
                formData.append('AssigneeType', assigneeTypeValue);
            }
            formData.append('Summary', currentAssignment.summary || "");
            formData.append('Description', currentAssignment.description || "");
            formData.append('NotifyAssignee', currentAssignment.notifyAssignee ? 'true' : 'false');
            formData.append('IsPrivate', currentAssignment.isPrivate ? 'true' : 'false');
            formData.append('Priority', currentAssignment.priority || 0);
            formData.append('EstimatedTime', currentAssignment.estimatedTime || 1);
            formData.append('Status', currentAssignment.status || 0);
            formData.append('DueDate', currentAssignment.dueDate || "");
            formData.append('Category', currentAssignment.category || "");
            formData.append('CreateDate', currentAssignment.createDate || "");


            if (currentAssignment.caseId) {
                formData.append('CaseId', currentAssignment.caseId);
            }

            if (currentAssignment.newAttachedDocuments?.length) {
                currentAssignment.newAttachedDocuments.forEach((file) => {
                    formData.append("NewAttachedDocuments", file, file.name);
                });
            }


            if (isAddMode) {
                // Add new assignment API call
                const response = await AssignmentService.CreateAssignment(formData, token);
                if (response.ok) {
                    toast.success(t("AssignmentAddedSuccessfully"));
                    const newAssignment = await response.json();
                    setAssignmentsPage((prev) => [...prev, newAssignment]);
                    if (currentAssignment.notifyAssignee && currentAssignment.assigneeId) {
                        await notifyAssigneeViaChat(currentAssignment);
                    }
                    setDialogOpen(false);
                    setIsAddMode(false);
                    fetchAssignments(
                        useDateFilter ? startDate : null, 
                        useDateFilter ? endDate : null, 
                        isRange, 
                        user.accountantId, 
                        token, 
                        client?.caseId
                    );
                } else {
                    toast.error(t("FailedToAddAssignment"));
                }
            } else {
                // Update existing assignment API call
                if (currentAssignment.attachedDocuments?.length) {
                    currentAssignment.attachedDocuments.forEach((url) => {
                        if (typeof url === "string") {
                            formData.append("AttachedDocuments", url);
                        } else {
                            console.warn("Skipping non-string document:", url);
                        }
                    });
                }
                formData.append('Id', currentAssignment.id);
                const response = await AssignmentService.UpdateAssignment(formData, token);
                if (response.ok) {
                    if (currentAssignment.notifyAssignee && currentAssignment.assigneeId) {
                        await notifyAssigneeViaChat(currentAssignment);
                    }
                    setDialogOpen(false);
                    setIsAddMode(false);
                    toast.success(t("AssignmentUpdatedSuccessfully"));
                    setLoading(false);
                    // Refresh assignments list
                    fetchAssignments(
                        useDateFilter ? startDate : null, 
                        useDateFilter ? endDate : null, 
                        isRange, 
                        user.accountantId, 
                        token, 
                        client?.caseId
                    );
                } else {
                    toast.error(t("FailedToUpdateAssignment"));
                    setLoading(false);
                }
            }
        } catch (error) {
            toast.error(isAddMode ? t("ErrorAddingAssignment") : t("ErrorUpdatingAssignment"));
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };



    const handleDeleteComment = async (commentId) => {
        try {
            const response = await AssignmentService.DeleteComment(commentId, user.accountantId, token); // Call your API
            if (response.ok) {
                setCurrentAssignment((prev) => ({
                    ...prev,
                    comments: prev.comments.filter((comment) => comment.id !== commentId),
                }));
                toast.success(t("CommentDeletedSuccessfully"));
                await fetchEnums(user, token, client);
            } else {
                toast.error(t("FailedToDeleteComment"));
            }
        } catch (error) {
            toast.error(t("AnErrorOccurredWhileDeletingComment"));
        }
    };

    const handleDropDocumentToAssignment = (event) => {
        event.preventDefault();
        const files = event.dataTransfer?.files;
        if (files?.length) {
            handleAddFilesToAssignment(Array.from(files));
        }
    };

    const handleRemoveDocumentFromAssignment = (indexToRemove) => {
        setCurrentAssignment((prev) => {
            const updatedAttachedDocuments = prev.attachedDocuments.filter((_, index) => index !== indexToRemove);
            const updatedNewAttachedDocuments = prev.newAttachedDocuments?.filter((_, index) => index !== indexToRemove);

            return {
                ...prev,
                attachedDocuments: updatedAttachedDocuments,
                newAttachedDocuments: updatedNewAttachedDocuments,
            };
        });
    };

    const handleDropDocumentToComment = (event) => {
        event.preventDefault();
        const files = event.dataTransfer?.files;
        if (files?.length) {
            handleAddFilesToComment(Array.from(files));
        }
    };

    const handleRemoveDocumentFromComment = (indexToRemove) => {
        setNewComment((prev) => {
            const updatedAttachedDocuments = prev.attachedDocuments.filter((_, index) => index !== indexToRemove);
            const updatedNewAttachedDocuments = prev.newAttachedDocuments?.filter((_, index) => index !== indexToRemove);

            return {
                ...prev,
                attachedDocuments: updatedAttachedDocuments,
                newAttachedDocuments: updatedNewAttachedDocuments,
            };
        });
    };

    const [selectedSubAccountants, setSelectedSubAccountants] = useState([]);
    const [selectedPriorities, setSelectedPriorities] = useState([]);


    const priorityOptions = Object.keys(Constants.PriorityEnum).map((key) => ({
        value: Constants.PriorityEnum[key],
        label: t(key),
    }));




    // const filteredAssignments = useMemo(() => {
    //     if (!Array.isArray(assignmentsPage)) {
    //         console.warn("assignmentsPage is not an array or is undefined, falling back to an empty array.");
    //         return [];
    //     }
    //     return assignmentsPage.filter((assignment) => {
    //         const matchesSubAccountant = selectedSubAccountants.length
    //             ? selectedSubAccountants.some((opt) => opt.value === assignment.assigneeId)
    //             : true;
    //         const matchesCaseId = selectedCaseIds.length
    //             ? selectedCaseIds.some((opt) => opt.value === assignment.caseId)
    //             : true;
    //         const matchesPriority = selectedPriorities.length
    //             ? selectedPriorities.some((opt) => opt.value === assignment.priority)
    //             : true;
    //         const matchesCategory = selectedCategories.length
    //             ? selectedCategories.some((opt) => opt.label === assignment.category)
    //             : true;
    //         return matchesSubAccountant && matchesCaseId && matchesPriority && matchesCategory;
    //     });
    // }, [assignmentsPage, selectedSubAccountants, selectedCaseIds, selectedPriorities, selectedCategories]);

    const filteredAssignments = useMemo(() => {

        if (!Array.isArray(assignmentsPage)) return [];

        // 1) Visibility: sub-accountants only see own reporter/assignee rows (server also enforces)
        let baseFiltered = assignmentsPage.filter((assignment) => {
            const viewerId = user?.subAccountantId || user?.accountantId;
            // Office manager = main Accountant user type (not sub-accountant)
            const isMainAccountant =
                Number(currentUserType) === Constants.UserTypeInt.Accountant
                || String(currentUserType) === String(Constants.UserType.Accountant)
                || String(currentUserType) === '2'
                || (!user?.subAccountantId && !!user?.accountantId);
            const matchesPrivacy = !assignment.isPrivate
                || isMainAccountant
                || assignment.reporterId === viewerId
                || assignment.assigneeId === viewerId;

            const matchesSubAccountant = selectedSubAccountants.length
                ? selectedSubAccountants.some((opt) => opt.value === assignment.assigneeId)
                : true;
            const matchesCaseId = selectedCaseIds.length
                ? selectedCaseIds.some((opt) => opt.value === assignment.caseId)
                : true;
            const matchesPriority = selectedPriorities.length
                ? selectedPriorities.some((opt) => opt.value === assignment.priority)
                : true;
            const matchesCategory = selectedCategories.length
                ? selectedCategories.some((opt) => opt.value === assignment.category)
                : true;

            return (
                matchesPrivacy &&
                matchesSubAccountant &&
                matchesCaseId &&
                matchesPriority &&
                matchesCategory
            );
        });


        // 2) Filter by searchQuery (summary/description fields, etc.)
        if (searchQuery.trim()) {
            const lowerSearch = searchQuery.toLowerCase();
            baseFiltered = baseFiltered.filter((assignment) => {
                // Check whichever fields you want
                const sum = assignment.summary?.toLowerCase() || "";
                const desc = assignment.description?.toLowerCase() || "";
                return sum.includes(lowerSearch) || desc.includes(lowerSearch);
            });
        }

        return baseFiltered;
    }, [
        assignmentsPage,
        selectedSubAccountants,
        selectedCaseIds,
        selectedPriorities,
        selectedCategories,
        searchQuery,
        user,
        currentUserType,
    ]);




    const pieChartData = useMemo(() => {
        const statusCounts = {
            ToDo: 0,
            InProgress: 0,
            Done: 0,
        };

        filteredAssignments.forEach((assignment) => {
            if (assignment.status === Constants.StatusEnum.ToDo) statusCounts.ToDo++;
            if (assignment.status === Constants.StatusEnum.InProgress) statusCounts.InProgress++;
            if (assignment.status === Constants.StatusEnum.Done) statusCounts.Done++;
        });

        const data = [
            { id: 0, value: statusCounts.ToDo, label: t('ToDo') },
            { id: 1, value: statusCounts.InProgress, label: t('InProgress') },
            { id: 2, value: statusCounts.Done, label: t('Done') },
        ];

        // Filter out zero values to avoid empty pie chart segments
        const filteredData = data.filter(item => item.value > 0);
        return filteredData;
    }, [filteredAssignments, t]);

    const startOfMonth = dayjs().startOf("month").toDate();
    const endOfMonth = dayjs().endOf("month").toDate();

    const assignmentsDoneThisMonth = useMemo(() => {
        return assignmentsPage.filter((assignment) => {
            const finishDate = assignment.finishDate ? new Date(assignment.finishDate) : null;
            return (
                assignment.status === Constants.StatusEnum.Done &&
                finishDate >= startOfMonth &&
                finishDate <= endOfMonth
            );
        });
    }, [assignmentsPage]);

    const daysInMonth = Array.from({ length: dayjs().daysInMonth() }, (_, i) => i + 1);

    const groupAssignmentsByDate = (assignments, startDate, endDate, isRangeMode) => {
        const start = dayjs(startDate);
        const end = isRangeMode ? dayjs(endDate) : dayjs(startDate);
        const rangeInDays = end.diff(start, 'days') + 1; // Total days in range
        const rangeInMonths = end.diff(start, 'month') + 1; // Total months in range

        const groupedData = {};

        // Determine key format: Month or Day
        const keyFormat = rangeInMonths > 2 ? 'YYYY-MM' : 'MM-DD';

        // Initialize keys for all months/days in range
        if (rangeInMonths > 2) {
            let currentMonth = start.startOf('month');
            while (currentMonth.isBefore(end.startOf('month')) || currentMonth.isSame(end.startOf('month'))) {
                groupedData[currentMonth.format(keyFormat)] = 0;
                currentMonth = currentMonth.add(1, 'month');
            }
        } else {
            let currentDate = start.startOf('day');
            while (currentDate.isBefore(end.startOf('day')) || currentDate.isSame(end.startOf('day'))) {
                groupedData[currentDate.format(keyFormat)] = 0;
                currentDate = currentDate.add(1, 'day');
            }
        }

        // Populate data for completed assignments
        assignments.forEach((assignment) => {
            if (assignment.status === Constants.StatusEnum.Done && assignment.finishDate) {
                const finishDate = dayjs(assignment.finishDate);
                const key = finishDate.format(keyFormat);
                if (groupedData[key] !== undefined) {
                    groupedData[key]++;
                }
            }
        });

        // Convert grouped data to array for the chart
        return Object.entries(groupedData).map(([key, count]) => ({
            x: key, // Month/Day
            y: count, // Total done assignments
        }));
    };


    const lineGraphData = useMemo(() => {
        const data = groupAssignmentsByDate(assignmentsPage, startDate, endDate, isRange);
        return data;
    }, [assignmentsPage, startDate, endDate, isRange]);

    const changeOnAssignment = (value) => {

        setCurrentAssignment({ ...currentAssignment, caseId: value.value });
    }

    const changeOnAssignmentCategory = (value) => {

        setCurrentAssignment({ ...currentAssignment, category: value.value });
    }

    // a) Create a ref for your hidden file input
    const fileInputRefUpload = useRef(null);

    const addFileToAssignment = (file) => {
        setCurrentAssignment((prev) => ({
            ...prev,
            attachedDocuments: [...(prev.attachedDocuments || []), file],
            newAttachedDocuments: [...(prev.newAttachedDocuments || []), file],
        }));
    };

    const handleAddFilesToAssignment = (files) => {
        if (!files?.length) return;
        setCurrentAssignment((prev) => ({
            ...prev,
            attachedDocuments: [...(prev.attachedDocuments || []), ...files],
            newAttachedDocuments: [...(prev.newAttachedDocuments || []), ...files],
        }));
    };

    const handleStartDateChange = (date) => {
        setStartDate(date);
        // Only fetch with date filter if date filtering is enabled
        if (useDateFilter && date) {
            fetchAssignments(date, endDate, isRange, user.accountantId, token, client?.caseId);
        }
    };

    const handleEndDateChange = (date) => {
        setEndDate(date);
        // Only fetch with date filter if date filtering is enabled
        if (useDateFilter && date) {
            fetchAssignments(startDate, date, isRange, user.accountantId, token, client?.caseId);
        }
    };



    const handleStartDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;


        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), startDate.getMonth(), 1));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(startDate.getFullYear(), newDate.getMonth(), 1));
        }

        setStartDate(updatedDate);
        // Only apply date filter if date filtering is enabled
        if (useDateFilter && updatedDate) {
            fetchAssignments(updatedDate, endDate, isRange, user.accountantId, token, client?.caseId);
        }
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), endDate.getMonth() + 1, 0));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDate.getFullYear(), newDate.getMonth() + 1, 0));
        }


        setEndDate(updatedDate);
        // Only apply date filter if date filtering is enabled
        if (useDateFilter && updatedDate) {
            fetchAssignments(startDate, updatedDate, isRange, user.accountantId, token, client?.caseId);
        }
    };


    const handleRangeChange = () => {
        const newRangeState = !isRange;
        setIsRange(newRangeState);
        // Fetch with date filter only if date filtering is enabled
        if (useDateFilter) {
            fetchAssignments(startDate, endDate, newRangeState, user.accountantId, token, client?.caseId);
        }
    };

    const handleToggleDateFilter = () => {
        const newDateFilterState = !useDateFilter;
        setUseDateFilter(newDateFilterState);
        
        if (newDateFilterState) {
            // Enable date filter - fetch with current dates
            fetchAssignments(startDate, endDate, isRange, user.accountantId, token, client?.caseId);
        } else {
            // Disable date filter - fetch all
            fetchAssignments(null, null, isRange, user.accountantId, token, client?.caseId);
        }
    };

    const fileInputRefComment = useRef(null);

    const handleUploadClickComment = () => {
        if (fileInputRefComment.current?.open) {
            fileInputRefComment.current.open();
        }
    };

    const handleCommentFileChange = (event) => {
        const files = event.target.files;
        if (files?.length) {
            handleAddFilesToComment(Array.from(files));
        }
        event.target.value = '';
    };

    const handleAddFilesToComment = (files) => {
        if (!files?.length) return;
        setNewComment((prev) => ({
            ...prev,
            attachedDocuments: [...(prev.attachedDocuments || []), ...files],
            newAttachedDocuments: [...(prev.newAttachedDocuments || []), ...files],
        }));
    };

    const [newCategoryModalOpen, setNewCategoryModalOpen] = useState(false);
    const [editCategoryModalOpen, setEditCategoryModalOpen] = useState(false);
    const [workPlanModalOpen, setWorkPlanModalOpen] = useState(false);
    const [assignmentReportModalOpen, setAssignmentReportModalOpen] = useState(false);
    const [newCategoryName, setNewCategoryName] = useState("");

    const handleOpenNewCategoryModal = () => {
        setNewCategoryName("");
        setNewCategoryModalOpen(true);
    };

    const handleCloseNewCategoryModal = () => {
        setNewCategoryModalOpen(false);
    };

    const handleCloseEditCategoryModal = () => {
        setEditCategoryModalOpen(false);
    };




    const handleSubmitNewCategory = async () => {
        try {

            if (!newCategoryName.trim()) {
                toast.error(t("CategoryNameRequired"));
                return;
            }
            const response = await AssignmentService.AddAssignmentCategory(
                user.accountantId,
                newCategoryName,
                token
            );
            if (response.ok) {
                toast.success(t("NewCategoryAddedSuccessfully"));
                const result = await response.json();
                const { accountantId, id, name, ...rest } = result;
                const categoryFormatted = { ...rest, value: id, label: name };

                setSelectedCategories([categoryFormatted]);
                setCurrentAssignment((prev) => ({
                    ...prev,
                    category: categoryFormatted,
                }));



                await fetchEnums(user, token, client);
                // setSelectedCategories([{ value: newCat.id, label: newCat.name }]);
                handleCloseNewCategoryModal();
            } else {
                toast.error(t("FailedToAddCategory"));
            }
        } catch (error) {
            console.error("Error adding new category:", error);
            toast.error(t("AnErrorOccurredWhileAddingCategory"));
        }
    };

    const handleSubmitEditCategory = async () => {
        try {

            if (!categoryToEditOrDelete.label.trim()) {
                toast.error(t("CategoryNameRequired"));
                return;
            }
            const response = await AssignmentService.UpdateAssignmentCategory(
                user.accountantId,
                categoryToEditOrDelete.value,
                categoryToEditOrDelete.label,
                token
            );

            if (response.ok) {
                toast.success(t("NewCategoryUpdatedSuccessfully"));
                await fetchEnums(user, token, client);
                handleCloseEditCategoryModal();
            } else {
                toast.error(t("FailedToAddCategory"));
            }
        } catch (error) {
            toast.error(t("AnErrorOccurredWhileAddingCategory"));
        }
    };

    const handleDeleteCategory = async (categoryToEditOrDelete) => {
        try {

            const response = await AssignmentService.DeleteAssignmentCategory(
                user.accountantId,  // Replace with the correct accountantId source
                categoryToEditOrDelete.value,
                token
            );

            if (!response.ok) {
                const errorMessage = await response.text();

                throw new Error(`Failed to delete category: ${errorMessage}`);
            }

            toast.success(t("CategoryDeletedSuccessfully"));
            await fetchEnums(user, token, client);
            handleCloseEditCategoryModal();
        } catch (error) {
            toast.error(t("FailedToDeleteCategory"));

        }
    };


    return (
        <>

            <Dialog
                open={newCategoryModalOpen}
                onClose={handleCloseNewCategoryModal}
            >
                <DialogTitle sx={{ textAlign: "center" }}>{t("AddNewCategory")}</DialogTitle>
                <DialogContent sx={{ padding: '30px' }}>
                    <TextField
                        label={t("CategoryName")}
                        value={newCategoryName}
                        onChange={(e) => setNewCategoryName(e.target.value)}
                        fullWidth
                        sx={{ marginTop: '20px' }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseNewCategoryModal}>{t("Cancel")}</Button>
                    <Button
                        onClick={async () => {
                            await handleSubmitNewCategory();
                        }}
                        variant="contained"
                        color="primary"
                    >
                        {t("Save")}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit category modal */}
            <Dialog
                open={editCategoryModalOpen}
                onClose={handleCloseNewCategoryModal}
            >
                <DialogTitle sx={{ textAlign: "center" }}>{t("Edit Category")}</DialogTitle>
                <DialogContent sx={{ padding: '30px' }}>
                    <TextField
                        label={t("CategoryName")}
                        value={categoryToEditOrDelete?.label}
                        onChange={(e) => {
                            if (categoryToEditOrDelete) {
                                setCategoryToEditOrDelete({
                                    ...categoryToEditOrDelete,
                                    label: e.target.value
                                });
                            }
                        }}
                        sx={{ marginTop: '20px' }}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseEditCategoryModal} size="small">{t("Cancel")}</Button>
                    <Button
                        onClick={async () => {
                            if (categoryToEditOrDelete) {
                                await handleDeleteCategory(categoryToEditOrDelete);
                            }
                        }}
                        variant="contained"
                        color="error"
                        startIcon={<DeleteIcon />}
                        size="small"
                    >
                        {t("Delete")}
                    </Button>
                    <Button
                        size="small"
                        onClick={async () => {
                            await handleSubmitEditCategory();
                        }}
                        variant="contained"
                        color="primary"
                    >
                        {t("Save")}
                    </Button>
                </DialogActions>
            </Dialog>



            <CustomDeleteConfirmationModal
                isVisible={isConfirmModalVisable}
                onClose={() => setIsConfirmModalVisable(false)}
                onDelete={handleDeleteClick}
                confirmMessage={getConfirmMessage()}
                titleMessage={getTitleMessage()}
                type={'delete'}
            />

            <AssignmentFilePreviewModal
                open={filePreviewModalOpen}
                onClose={handleCloseFilePreviewModal}
                url={previewFileInfo.url}
                fileName={previewFileInfo.fileName}
                mimeType={previewFileInfo.mimeType}
            />
            <AssignmentDialog
                /* Dialog Control */
                open={dialogOpen}
                onClose={handleCloseDialog}

                /* Modes */
                isEditMode={isEditMode}
                isAddMode={isAddMode}

                /* Assignment data + setter */
                currentAssignment={currentAssignment}
                setCurrentAssignment={setCurrentAssignment}

                /* Arrays/Data */
                subAccountants={subAccountants}
                categoryOptions={categoryOptions}
                caseIdOptions={caseIdOptions}

                /* Parent Handlers */
                handleSaveAssignment={handleSaveAssignment}
                handleEditAssignment={handleEditAssignment}
                handleDeleteAssignment={handleDeleteClick}
                handleCloseDialog={handleCloseDialog}
                setIsConfirmModalVisable={setIsConfirmModalVisable}
                handleOpenModal={handleOpenModal}
                handleOpenNewCategoryModal={handleOpenNewCategoryModal}
                changeOnAssignmentCategory={changeOnAssignmentCategory}
                changeOnAssignment={changeOnAssignment}

                /* File & Comment Handlers */
                handleDropDocumentToAssignment={handleDropDocumentToAssignment}
                handleAddFilesToAssignment={handleAddFilesToAssignment}
                handleFileChange={handleFileChange}
                handleRemoveDocumentFromAssignment={handleRemoveDocumentFromAssignment}
                handleDropDocumentToComment={handleDropDocumentToComment}
                handleAddFilesToComment={handleAddFilesToComment}
                handleCommentFileChange={handleCommentFileChange}
                handleRemoveDocumentFromComment={handleRemoveDocumentFromComment}
                handleUploadClick={handleUploadClick}
                fileInputRefUpload={fileInputRefUpload}
                handleUploadClickComment={handleUploadClickComment}
                fileInputRefComment={fileInputRefComment}

                /* Description & Comments */
                handleChangeCurrentDescription={handleChangeCurrentDescription}
                handleChangeNewCommentContent={handleChangeNewCommentContent}
                newComment={newComment}
                handleAddComment={handleAddComment}
                handleDeleteComment={handleDeleteComment}

                /* Helpers */
                formatDate={formatDate}
                formatDateWithHour={formatDateWithHour}

                /* Auth/User */
                user={user}

                /* i18n */
                t={t}
                direction={direction}
            />

            <WorkPlanManager
                open={workPlanModalOpen}
                onClose={() => setWorkPlanModalOpen(false)}
                assignments={assignmentsPage}
                subAccountants={subAccountants}
                caseIdOptions={caseIdOptions}
                categoryOptions={categoryOptions}

            />

            <AssignmentReportManager
                open={assignmentReportModalOpen}
                onClose={() => setAssignmentReportModalOpen(false)}
                assignments={assignmentsPage}
                subAccountants={subAccountants}
                caseIdOptions={caseIdOptions}
                categoryOptions={categoryOptions}
                startDate={startDate}
                endDate={endDate}
            />

            <>
                <>
                    {/* Compact FilterBar Style Layout - Single Row with Charts */}
                    <div style={{
                        display: 'flex',
                        gap: '12px',
                        alignItems: 'flex-start',
                        marginBottom: '16px',
                        flexWrap: 'nowrap',
                        minHeight: '60px'
                    }}>
                        {/* FilterBar Section */}
                        <div className={`filter-bar-container unified ${direction}`} style={{ flex: '1', minWidth: '0' }}>
                            <div className="unified-filter-section">
                                <div className="filter-content" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    flexWrap: 'nowrap',
                                    width: '100%',
                                    padding: '8px 12px',
                                    flexDirection: 'column'
                                }}>

                                    <div className="filter-content" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        flexWrap: 'nowrap',
                                        width: '100%',
                                        padding: '8px 12px',
                                    }}>

                                        {/* Action Buttons */}
                                        <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                                            <Button
                                                onClick={() => setWorkPlanModalOpen(true)}
                                                variant="outlined"
                                                startIcon={<AssignmentIcon sx={{ fontSize: '14px' }} />}
                                                sx={{
                                                    border: '1px solid rgba(48, 79, 255, 0.3)',
                                                    color: '#304fff',
                                                    fontWeight: 600,
                                                    px: 1.5,
                                                    py: 0.5,
                                                    borderRadius: '6px',
                                                    textTransform: 'none',
                                                    fontSize: '11px',
                                                    minWidth: 'auto',
                                                    height: '32px',
                                                    '&:hover': {
                                                        borderColor: 'rgba(48, 79, 255, 0.5)',
                                                        backgroundColor: 'rgba(48, 79, 255, 0.05)'
                                                    }
                                                }}
                                            >
                                                {t("WorkPlan")}
                                            </Button>

                                            <Button
                                                onClick={() => setAssignmentReportModalOpen(true)}
                                                variant="outlined"
                                                startIcon={<AssessmentIcon sx={{ fontSize: '14px' }} />}
                                                sx={{
                                                    border: '1px solid rgba(48, 79, 255, 0.3)',
                                                    color: '#304fff',
                                                    fontWeight: 600,
                                                    px: 1.5,
                                                    py: 0.5,
                                                    borderRadius: '6px',
                                                    textTransform: 'none',
                                                    fontSize: '11px',
                                                    minWidth: 'auto',
                                                    height: '32px',
                                                    '&:hover': {
                                                        borderColor: 'rgba(48, 79, 255, 0.5)',
                                                        backgroundColor: 'rgba(48, 79, 255, 0.05)'
                                                    }
                                                }}
                                            >
                                                {t("AssignmentReport")}
                                            </Button>

                                            <Button
                                                onClick={handleAddAssignment}
                                                variant="contained"
                                                startIcon={<AddCircleIcon sx={{ fontSize: '14px' }} />}
                                                sx={{
                                                    background: 'linear-gradient(45deg, #FF6B6B, #FF8E53)',
                                                    color: 'white',
                                                    fontWeight: 600,
                                                    px: 1.5,
                                                    py: 0.5,
                                                    borderRadius: '6px',
                                                    textTransform: 'none',
                                                    fontSize: '11px',
                                                    minWidth: 'auto',
                                                    height: '32px',
                                                    boxShadow: '0 2px 6px rgba(255,107,107,0.3)',
                                                    '&:hover': {
                                                        background: 'linear-gradient(45deg, #FF5252, #FF7043)',
                                                        transform: 'translateY(-1px)',
                                                    },
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                {t("AddAssignment")}
                                            </Button>
                                        </Box>

                                        {/* Date Filter Toggle Button */}
                                        <Button
                                            onClick={handleToggleDateFilter}
                                            variant={useDateFilter ? "contained" : "outlined"}
                                            startIcon={<DateRangeIcon sx={{ fontSize: '14px' }} />}
                                            sx={{
                                                border: useDateFilter ? 'none' : '1px solid rgba(48, 79, 255, 0.3)',
                                                background: useDateFilter ? 'linear-gradient(45deg, #304fff, #5c7cfa)' : 'transparent',
                                                color: useDateFilter ? 'white' : '#304fff',
                                                fontWeight: 600,
                                                px: 1.5,
                                                py: 0.5,
                                                borderRadius: '6px',
                                                textTransform: 'none',
                                                fontSize: '11px',
                                                minWidth: 'auto',
                                                height: '32px',
                                                boxShadow: useDateFilter ? '0 2px 6px rgba(48,79,255,0.3)' : 'none',
                                                '&:hover': {
                                                    borderColor: 'rgba(48, 79, 255, 0.5)',
                                                    backgroundColor: useDateFilter ? '#2a45e5' : 'rgba(48, 79, 255, 0.05)',
                                                    transform: 'translateY(-1px)',
                                                },
                                                transition: 'all 0.2s ease'
                                            }}
                                        >
                                            {useDateFilter ? t("DateFilterOn") : t("DateFilterOff")}
                                        </Button>

                                        {/* Search Bar */}
                                        <div style={{ minWidth: '180px', flex: '0 0 180px' }}>
                                            <TextField
                                                placeholder={t('Search')}
                                                value={searchQuery}
                                                onChange={(e) => setSearchQuery(e.target.value)}
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        height: '32px',
                                                        fontSize: '12px',
                                                        '& fieldset': {
                                                            borderColor: 'rgba(48, 79, 255, 0.2)',
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: 'rgba(48, 79, 255, 0.4)',
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: '#304fff',
                                                        },
                                                    }
                                                }}
                                                InputProps={{
                                                    ...(direction === 'ltr' ? {
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <SearchIcon sx={{ fontSize: '16px', color: '#304fff' }} />
                                                            </InputAdornment>
                                                        ),
                                                    } : {
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SearchIcon sx={{ fontSize: '16px', color: '#304fff' }} />
                                                            </InputAdornment>
                                                        ),
                                                    })
                                                }}
                                                inputProps={{
                                                    style: {
                                                        textAlign: direction === 'rtl' ? 'right' : 'left',
                                                        direction: direction === 'rtl' ? 'rtl' : 'ltr',
                                                        padding: '6px 8px'
                                                    },
                                                }}
                                            />
                                        </div>


                                
                                    </div>

                                    <div className="filter-content" style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        flexWrap: 'nowrap',
                                        width: '100%',
                                        padding: '8px 12px',
                                    }}>

                                


                                        {/* Filters */}
                                        <div style={{ display: 'flex', gap: '8px', flex: '1', minWidth: '0' }}>
                                            <AutocompleteSelect
                                                options={subAccountantOptions}
                                                selectedValues={selectedSubAccountants}
                                                onChange={(event, values) => setSelectedSubAccountants(values)}
                                                label={t("SubAccountant")}
                                                placeholder={t("SelectSubAccountant")}
                                                width="200px"
                                                inputHeight={32}
                                            />
                                            <AutocompleteSelect
                                                options={caseIdOptions}
                                                selectedValues={selectedCaseIds}
                                                onChange={(event, values) => handleSetSelectedCaseIds(values)}
                                                label={t("Client Name")}
                                                placeholder={t("SelectCustomer")}
                                                width="200px"
                                                inputHeight={32}
                                            />
                                            <AutocompleteSelect
                                                options={priorityOptions}
                                                selectedValues={selectedPriorities}
                                                onChange={(event, values) => setSelectedPriorities(values)}
                                                label={t("Priority")}
                                                placeholder={t("SelectPriority")}
                                                width="150px"
                                                inputHeight={32}
                                            />
                                            <AutocompleteSelect
                                                options={categoryOptions}
                                                selectedValues={selectedCategories}
                                                onRightClick={handleEditCategory}
                                                onChange={(event, values) => {
                                                    if (Array.isArray(values)) {
                                                        const filteredValues = values.filter(v => v.value !== "NEW_CATEGORY");
                                                        const foundNewCategory = values.some(v => v.value === "NEW_CATEGORY");
                                                        setSelectedCategories(filteredValues);
                                                        if (foundNewCategory) {
                                                            handleOpenNewCategoryModal();
                                                        }
                                                    } else {
                                                        if (values?.value === "NEW_CATEGORY") {
                                                            handleOpenNewCategoryModal();
                                                            setSelectedCategories(null);
                                                        } else {
                                                            setSelectedCategories(values);
                                                        }
                                                    }
                                                }}
                                                label={t("Category")}
                                                placeholder={t("SelectCategory")}
                                                width="200px"
                                                inputHeight={32}
                                            />
                                        </div>
                                    </div>


                                    {/* Date Range - Only show when date filter is enabled */}
                                    {useDateFilter && (
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', width: '50%',alignSelf: 'flex-start'}}>
                                            {isRange ? (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <CustomMonthYearIndividualDatePicker
                                                        year={startDate}
                                                        month={startDate}
                                                        onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                                        onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                                        labelYear={t("StartYear")}
                                                        labelMonth={t("StartMonth")}
                                                       
                                                        height="28px"
                                                    />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            size="small"
                                                            color="primary"
                                                            checked={isRange}
                                                            onChange={handleRangeChange}
                                                            sx={{ margin: 0 }}
                                                        />
                                                    }
                                                    label={
                                                        <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#304fff' }}>
                                                            {t("DateRange")}
                                                        </Typography>
                                                    }
                                                    sx={{ margin: 0, marginRight: '4px', marginLeft: '4px' }}
                                                />
                                                <CustomMonthYearIndividualDatePicker
                                                    year={endDate}
                                                    month={endDate}
                                                    onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                                    onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                                    labelYear={t("EndYear")}
                                                    labelMonth={t("EndMonth")}
                                                   
                                                    height="28px"
                                                />
                                                </div>
                                            ) : (
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <CustomMonthYearIndividualDatePicker
                                                        year={startDate}
                                                        month={startDate}
                                                        onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                                        onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                                        labelYear={t("Year")}
                                                        labelMonth={t("Month")}
                                                       
                                                        height="28px"
                                                    />
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                size="small"
                                                                color="primary"
                                                                checked={isRange}
                                                                onChange={handleRangeChange}
                                                                sx={{ margin: 0 }}
                                                            />
                                                        }
                                                        label={
                                                            <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#304fff' }}>
                                                                {t("DateRange")}
                                                            </Typography>
                                                        }
                                                        sx={{ margin: 0, marginRight: '4px', marginLeft: '4px' }}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                


                                </div>
                            </div>
                        </div>

                        {/* Analytics Charts - Same Row as FilterBar */}
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: 0.5,
                            alignItems: 'center',
                            minWidth: '200px',
                            height: '150px'
                        }}>
                            {/* Bar Chart */}
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 0.25,
                                padding: '4px',
                                background: 'rgba(76, 175, 80, 0.05)',
                                borderRadius: '6px',
                                border: '1px solid rgba(76, 175, 80, 0.2)',
                                height: '140px',
                                justifyContent: 'center',
                                marginTop: '10px'
                            }}>
                                <Typography variant="caption" sx={{
                                    color: '#2c3e50',
                                    fontWeight: 600,
                                    fontSize: '10px',
                                    textAlign: 'center'
                                }}>
                                    {t("TasksDone")}
                                </Typography>
                                <BarChart
                                    xAxis={[
                                        {
                                            data: lineGraphData.map((item) => item.x),
                                            scaleType: "band",
                                            label: isRange && dayjs(endDate).diff(dayjs(startDate), 'month') > 2
                                                ? t("Month")
                                                : t("Day"),
                                        },
                                    ]}
                                    series={[
                                        {
                                            data: lineGraphData.map((item) => item.y),
                                            label: t("TasksDone"),
                                        },
                                    ]}
                                    width={200}
                                    height={150}
                                    colors={['#4CAF50']}

                                />
                            </Box>

                            {/* Pie Chart */}
                            <Box sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                background: 'rgba(33, 150, 243, 0.05)',
                                borderRadius: '6px',
                                border: '1px solid rgba(33, 150, 243, 0.2)',
                                height: '140px',
                                justifyContent: 'center',
                                marginTop: '10px'
                            }}>
                                <Typography variant="caption" sx={{
                                    color: '#2c3e50',
                                    fontWeight: 600,
                                    fontSize: '10px',
                                    textAlign: 'center'
                                }}>
                                    {t("Status")}
                                </Typography>
                                <PieChart
                                    series={[
                                        {
                                            data: pieChartData,
                                            highlightScope: { fade: 'global', highlight: 'item' },
                                            faded: { innerRadius: 10, additionalRadius: -10, color: 'gray' },

                                        },
                                    ]}
                                    width={200}
                                    height={150}
                                    colors={['#FF6B6B', '#4CAF50', '#2196F3']}

                                />
                            </Box>
                        </Box>
                    </div>

                    {/* current table */}
                    <div
                        className="table-container"
                        style={{
                            overflowX: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0 16px",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                gap: 3,
                                p: 1.5,
                                width: "100%",
                                flexDirection: "row",
                                overflowX: "auto",
                                justifyContent: "space-around",
                            }}
                        >
                            {(clickedTable === '' || clickedTable === 'todo') &&
                                <Box sx={{
                                    minWidth: clickedTable === 'todo' ? '100%' : 'auto',
                                    flex: clickedTable === 'todo' ? 'none' : '0 0 auto',
                                }}>
                                    <GenericTable
                                        title={t("ToDo")}
                                        data={filteredAssignments}
                                        columns={columns}
                                        filterFn={(assignment) => assignment.status === Constants.StatusEnum.ToDo}
                                        noDataMessage={t("NoData")}
                                        onDropStatus={(draggedId) =>
                                            handleStatusChange(draggedId, Constants.StatusEnum.ToDo)
                                        }
                                        tableRef={todoTableRef}
                                        handleChangeClickedTable={handleChangeClickedTable}
                                        onRowClick={handleOpenEditDialog}
                                        whatTable={'todo'}
                                    />
                                </Box>
                            }
                            {(clickedTable === '' || clickedTable === 'inprogress') &&
                                <Box sx={{
                                    minWidth: clickedTable === 'inprogress' ? '100%' : 'auto',
                                    flex: clickedTable === 'inprogress' ? 'none' : '0 0 auto'
                                }}>
                                    <GenericTable
                                        title={t("InProgress")}
                                        data={filteredAssignments}
                                        columns={columns}
                                        filterFn={(assignment) => assignment.status === Constants.StatusEnum.InProgress}
                                        noDataMessage={t("NoData")}
                                        handleChangeClickedTable={handleChangeClickedTable}
                                        onDropStatus={(draggedId) =>
                                            handleStatusChange(draggedId, Constants.StatusEnum.InProgress)
                                        }
                                        tableRef={todoTableRef}
                                        onRowClick={handleOpenEditDialog}
                                        whatTable={'inprogress'}
                                    />
                                </Box>
                            }
                            {(clickedTable === '' || clickedTable === 'done') &&
                                <Box sx={{
                                    minWidth: clickedTable === 'done' ? '100%' : 'auto',
                                    flex: clickedTable === 'done' ? 'none' : '0 0 auto'
                                }}>
                                    <GenericTable
                                        title={t("Done")}
                                        data={filteredAssignments}
                                        columns={columnsDoneTable}
                                        handleChangeClickedTable={handleChangeClickedTable}
                                        filterFn={(assignment) => assignment.status === Constants.StatusEnum.Done}
                                        noDataMessage={t("NoData")}
                                        onDropStatus={(draggedId) =>
                                            handleStatusChange(draggedId, Constants.StatusEnum.Done)
                                        }
                                        tableRef={todoTableRef}
                                        onRowClick={handleOpenEditDialog}
                                        whatTable={'done'}
                                    />
                                </Box>
                            }
                        </Box>
                    </div>


                </>
                {/* <HamburgerMenu client={client} /> */}

                <ToastContainer />
                {loading && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={loading}
                        />
                    </div>
                )}
            </>

        </>
    );
}


export default Assignments;